import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { Document } from "../../../../../models/Document";
import { AppStateWithData } from "../../../../AppStateWithData";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { ArticleCreationInfo,CustomInputCreationInfo } from "./DocumentCreationInfo";
import { processResponseCreateCustomInput } from "./processResponseCreateCustomInput";

export const createCustomInputActionTypes = createRequestActionTypes('CREATE_CUSTOM_INPUT')
export const createCustomInputSilentActionTypes = createRequestActionTypes('CREATE_CUSTOM_INPUT_SILENT')

export type CreateItemAdditionalData = {
    groupUid?: string | null
    laneId?: number
}

export type CreateItemSilentAdditionalData = CreateItemAdditionalData & {
    needCloseInput?: boolean
}

export const getGroupInfoFromCreation = (articleCreationInfo: CustomInputCreationInfo | ArticleCreationInfo) => {
    const groupUid = articleCreationInfo?.permissions?.groupUid
    const kanbanListId = articleCreationInfo?.kanbanListId
    const laneId = !kanbanListId ? -1 : Number(kanbanListId) ?? -1
    return {groupUid, laneId}
}

export const createCustomInput = (config: ApiConfig) => (articleCreationInfo: CustomInputCreationInfo) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const groupInfo = getGroupInfoFromCreation(articleCreationInfo)

    const thunkParams: RequestThunkParameters<Document, CustomInputCreationInfo, CreateItemAdditionalData> = {
        method: 'POST',
        body: articleCreationInfo,
        actionAdditionalData: {
            laneId: groupInfo.laneId,
            groupUid: groupInfo.groupUid
        },
        requestActionTypes: createCustomInputActionTypes,
        url: `${config.API_URL}/content/create/custominput`,
        processResultBeforeDispatch: (res) => processResponseCreateCustomInput(config, dispatch)(res, false)
    }

    dispatch<any>(createRequestThunk(thunkParams))
}

export const createCustomInputSilent = (config: ApiConfig) => (articleCreationInfo: CustomInputCreationInfo, needCloseInput?: boolean) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const groupInfo = getGroupInfoFromCreation(articleCreationInfo)

    const thunkParams: RequestThunkParameters<Document, CustomInputCreationInfo, CreateItemSilentAdditionalData> = {
        method: 'POST',
        body: articleCreationInfo,
        actionAdditionalData: {
            laneId: groupInfo.laneId,
            needCloseInput,
            groupUid: groupInfo.groupUid
        },
        requestActionTypes: createCustomInputSilentActionTypes,
        url: `${config.API_URL}/content/create/custominput`,
        processResultBeforeDispatch: (res) => processResponseCreateCustomInput(config, dispatch)(res, true)
    }

    dispatch<any>(createRequestThunk(thunkParams))
}